<template>
	<div class="app">
		<Html :lang="locale" />
		<!-- definePageMeta -->
		<Head>
			<Link v-if="isPolishHrefLang" rel="alternate" hreflang="pl" :href="getHrefLangURL('pl')" />
			<Link v-if="isEnglishHrefLang" rel="alternate" hreflang="en" :href="getHrefLangURL('en')" />
		</Head>
		<NuxtLoadingIndicator color="var(--primary-color)" />
		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>
	</div>
</template>
<script setup lang="ts">
const { locale } = useI18n()
const isPolishHrefLang = ref(true)
const isEnglishHrefLang = ref(true)
const currency = useCookie('currency')
const router = useRouter()
if (!currency.value) {
	currency.value = ECurrency.PLN
}

const currencyExchangeRate = useCookie('currency-exchange-rate')
if (!currencyExchangeRate.value) {
	currencyExchangeRate.value = '1'
}

if (process.client)
	window.addEventListener('vite:preloadError', () => {
		window.location.reload()
	})

const setPolishHrefLang = () => {
	if (process.client) {
		isPolishHrefLang.value =
			router.currentRoute.value.name !== 'news-newsID-newsTitle___en' && router.currentRoute.value.name !== 'car-rental-urlSlug___en'
	} else isPolishHrefLang.value = !useRequestURL().href.includes('/post/') && !useRequestURL().href.includes('/car-rental-')
}

const setEnglishHrefLang = () => {
	if (process.client) {
		isEnglishHrefLang.value =
			router.currentRoute.value.name !== 'news-newsID-newsTitle___pl' && router.currentRoute.value.name !== 'car-rental-urlSlug___pl'
	} else isEnglishHrefLang.value = !useRequestURL().href.includes('/aktualnosc/') && !useRequestURL().href.includes('/wypozyczalnia-samochodow-')
}

const currencyStore = useCurrenciesStore()
setPolishHrefLang()
setEnglishHrefLang()

const getCurrencyRates = () => {
	try {
		// const data = await ApiService.fetchCurrenciesExchangeRates()
		const convertedData = {
			PLN: 1,
			USD: 1,
			GBP: 1,
			EUR: 1,
		}
		// data.forEach((curr) => {
		// 	convertedData[curr.currencyTo] = curr.rate
		// })
		currencyStore.setExchangeRates(convertedData)
		if (!currency.value) {
			currency.value = ECurrency.PLN
		}
		currencyExchangeRate.value = convertedData[currency.value]
	} catch (e) {
		console.log(e)
	}
}

getCurrencyRates()

watch(
	() => router.currentRoute.value,
	() => {
		setEnglishHrefLang()
		setPolishHrefLang()
	},
	{ deep: true },
)
</script>
<style lang="scss"></style>
